import { ReactNode } from 'react';

interface PageBackgroundProps {
  children: ReactNode;
  className?: string;
}

/**
 * PageBackground - A generic wrapper component that provides a static gradient background
 * with scrollable content overlay. The gradient stays fixed while child content scrolls.
 */
export const PageBackground: React.FC<PageBackgroundProps> = ({ children, className = '' }) => {
  return (
    <div className="fixed inset-0 bg-transparent">
      <div className={`h-full overflow-y-auto ${className}`}>
        {children}
      </div>
    </div>
  );
};
